import axios from 'axios';
import { BASE_URL } from '../../../../BaseUrl';
import { MODE_ID } from '../../../../utils.js';

const token = localStorage.getItem('usertoken');

// Get all content API
export const getAllContent = async (params = {}) => {
  const { page_no = 1, page_size = 11 } = params;
  
  console.log('getAllContent called with params:', params);
  console.log('BASE_URL:', BASE_URL);
  console.log('MODE_ID:', MODE_ID);
  console.log('Token:', token);
  
  const options = {
    headers: {
      'x-access-token': token
    }
  };
  
  try {
    const url = `${BASE_URL}/Content/getall/${MODE_ID}?page_no=${page_no}&page_size=${page_size}`;
    console.log('API URL:', url);
    
    const response = await axios.get(url, options);
    console.log('API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getAllContent error:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

// Get content by ID API
export const getContentById = async (contentId) => {
  const options = {
    headers: {
      'x-access-token': token
    }
  };
  
  try {
    const response = await axios.get(
      `${BASE_URL}/Content/getById/${contentId}`,
      options
    );
    return response.data;
  } catch (error) {
    console.error('getContentById error:', error);
    throw error;
  }
};
